// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Button, ButtonProps, ButtonTypeMap } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';
import React, { useContext } from 'react';

import { ZkidWalletContext } from '../ZkidWallet';

function ButtonEnable(props: ButtonProps): React.ReactElement;
function ButtonEnable<C extends React.ElementType>(
  props: { component: C } & OverrideProps<ButtonTypeMap, C>
): React.ReactElement;
function ButtonEnable<C extends React.ElementType>(
  props: ButtonProps | ({ component: C } & OverrideProps<ButtonTypeMap, C>)
) {
  const { didUrl, login } = useContext(ZkidWalletContext);

  return didUrl ? (
    <Button {...props} />
  ) : (
    <Button {...props} onClick={login}>
      Connect Wallet
    </Button>
  );
}

export default ButtonEnable;
